import { render } from "./App.vue?vue&type=template&id=51a7f660"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=51a7f660&lang=css"

import exportComponent from "C:\\wamp64\\www\\vrs_yii2_new\\vuejs\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__